import React from 'react';
import {PageNavigation} from '@ignitesales/neuro-application';
import Footer from "../Footer.jsx";

const SurveyPage = ({ className, renderQuestionGroups }) => {

  return <>
    <div className={className}>
      <div className="questionGroups clear">{ renderQuestionGroups() }</div>
    </div>
    <Footer>
      <PageNavigation
        innerNextBtn={<>Next <i className="fa fa-caret-right"/></>}
        innerPrevBtn={<><i className="fa fa-caret-left"/> Back</>}
      />
    </Footer>
  </>;
};

export default SurveyPage;
